/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Alert API Specification
 * OpenAPI spec version: 0.0.7
 */

export type GetV9AlertsAlertRulesCurrentPlatformTypesItem =
  (typeof GetV9AlertsAlertRulesCurrentPlatformTypesItem)[keyof typeof GetV9AlertsAlertRulesCurrentPlatformTypesItem];

export const GetV9AlertsAlertRulesCurrentPlatformTypesItem = {
  application: 'application',
  awsDms: 'awsDms',
  awsDocumentDB: 'awsDocumentDB',
  awsDynamoDB: 'awsDynamoDB',
  awsEC2: 'awsEC2',
  awsElasticache: 'awsElasticache',
  awsLambda: 'awsLambda',
  awsRedshift: 'awsRedshift',
  awsS3: 'awsS3',
  azureBlobStorage: 'azureBlobStorage',
  azureCacheForRedis: 'azureCacheForRedis',
  azureCacheForRedisEnterprise: 'azureCacheForRedisEnterprise',
  azureCosmosDB: 'azureCosmosDB',
  azureDatabaseForMysql: 'azureDatabaseForMysql',
  azureDatabaseForPostgresql: 'azureDatabaseForPostgresql',
  azureFunctions: 'azureFunctions',
  azureSqlDatabase: 'azureSqlDatabase',
  azureVirtualMachines: 'azureVirtualMachines',
  business: 'business',
  cluster: 'cluster',
  container: 'container',
  cronjob: 'cronjob',
  daemonset: 'daemonset',
  database: 'database',
  database_cluster: 'database_cluster',
  deployment: 'deployment',
  gpu: 'gpu',
  host: 'host',
  hpa: 'hpa',
  job: 'job',
  kafka: 'kafka',
  kafka_broker: 'kafka_broker',
  kafka_cluster: 'kafka_cluster',
  logs: 'logs',
  namespace: 'namespace',
  networkDevice: 'networkDevice',
  networkObject: 'networkObject',
  node: 'node',
  persistentVolume: 'persistentVolume',
  persistentVolumeClaim: 'persistentVolumeClaim',
  pod: 'pod',
  replicaset: 'replicaset',
  route: 'route',
  rum: 'rum',
  service: 'service',
  statefulset: 'statefulset',
  storageClass: 'storageClass',
  url: 'url',
  webserver: 'webserver',
} as const;
